import React from 'react';
import * as yup from 'yup';
import AuthForm from './AuthForm';
import { Text } from '@chakra-ui/react';
import AuthWrapper from './AuthWrapper';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { triggerPasswordReset } from '../../api/auth';
import { PHONE_NO_REGEX } from '../../constants/regex';
import { notify } from '../../store/actions/globalActions';
import { LOG_IN_URL, PASSWORD_RESET_VERIFICATION_URL } from '../../constants/routerUrl';

const ForgetPassword = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    const sendData = {
      username: data.username,
      phoneNo: `+880${data.phone.slice(-10)}`,
    };
    try {
      const res = await triggerPasswordReset(sendData);
      if (res.status === 200) {
        dispatch(
          notify({
            title: 'Success',
            description: res.data.msg,
            status: 'success',
            duration: 5000,
          }),
        );
        history.replace({
          pathname: PASSWORD_RESET_VERIFICATION_URL,
          state: {
            phoneNo: data.phone,
            username: data.username,
            minPassLength: res.data.minPassLength,
          },
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const ForgetPasswordValidationSchema = yup.object().shape({
    username: yup.string().required().label('Username'),
    phone: yup
      .string()
      .matches(PHONE_NO_REGEX, 'Not a valid phone no.')
      .required()
      .label('Phone Number'),
  });

  const formFields = [
    {
      id: 'username',
      name: 'username',
      isRequired: true,
      type: 'text',
      label: 'Username',
      placeholder: 'Enter your username',
    },
    {
      id: 'phone',
      name: 'phone',
      isRequired: true,
      type: 'tel',
      label: 'Phone Number',
      placeholder: 'Enter your phone number',
    },
  ];

  return (
    <AuthWrapper>
      <AuthForm
        columns={1}
        onSubmit={onSubmit}
        formSubmitName="NEXT"
        formFields={formFields}
        formName="Reset Password"
        validationSchema={ForgetPasswordValidationSchema}
        formText="Please enter your username & phone number to receive OTP for resetting your password."
        extraField={
          <Link to={LOG_IN_URL} style={{ maxWidth: 'fit-content' }}>
            <Text
              fontSize="sm"
              opacity={0.45}
              transition="0.5s"
              color="primary.700"
              _hover={{ opacity: 1 }}>
              Back to Login?
            </Text>
          </Link>
        }
      />
    </AuthWrapper>
  );
};

export default ForgetPassword;
